import { BanIcon } from 'lucide-react';
import { ErrorPageTemplate } from './ErrorTemplate';

export const UnexpectedErrorPage = () => {
  return (
    <ErrorPageTemplate
      Icon={BanIcon}
      errorCode={500}
      errorMessage="An Unexpected Error has occured."
    />
  );
};
